import type { i18n } from "i18next";

export const resetLanguageToBrowserSettings = (i18n: i18n) => {
  try {
    localStorage.removeItem("i18nextLng");
    const languages = i18n.services.languageDetector.detect();
    i18n.changeLanguage(languages?.length > 0 ? languages[0] : i18n.options.fallbackLng);
  } catch {
    i18n.changeLanguage(i18n.options.fallbackLng as string);
  }
};
